/** Base path for booking pages in the client package (Next.js dynamic routes) */
export const BOOKINGS_PATH = '/bookings'

/**
 * Holds whichever credential the secure booking endpoint is called with: an OTP
 * access token, or a Back Office HMAC token with its `backoffice:` prefix.
 */
export const BOVIO_OTP_COOKIE = 'bovio-otpToken'

/** HMAC access token Back Office puts on the BMP links CS agents open. */
export const BOOKING_ACCESS_TOKEN_PARAM = 'accessToken'

/** How BoVio tells HMAC tokens from OTP ones on the Authorization header. */
export const BACKOFFICE_TOKEN_PREFIX = 'backoffice:'

/** BoVio hardcodes a 30 minute TTL on Back Office HMAC tokens. */
export const BACKOFFICE_TOKEN_TTL_MS = 30 * 60 * 1000
